import AuthService from '../services/auth.service'

const authUser = AuthService.getUser();
const email = AuthService.getSavedEmail();
const initialState = authUser
  ? { status: { isSignedIn: true }, user: authUser, email }
  : { status: { isSignedIn: false }, user: null, email };

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async signin({ commit, dispatch }, {user, isSaveEmail}) {
      try {
        const res = await AuthService.signin(user);
        if(isSaveEmail) {
          AuthService.saveEmail(user.email);
          commit('saveEmail', user.email);
        } else {
          AuthService.removeEmail();
          commit('removeEmail');
        }
        commit('signin', res);
        dispatch('my/history', null, {root: true})
        return res;
      } catch(e) {
        commit('signout');
        throw e;
      }
    },

    getToken() {
      return AuthService.getToken();
    },

    setToken({ commit }, token) {
      commit('signin', AuthService.getUser(token));
    },

    async getUserGuideUrl() {
      return await AuthService.getUserGuideUrl();
    },

    setUser({ commit }, user) {
      commit('signin', user);
    },

    signout({ commit, dispatch }) {
      AuthService.signout();
      commit('signout');
      dispatch('my/history', null, {root: true})
    },
  },
  mutations: {
    signin(state, user) {
      state.status.isSignedIn = true;
      state.user = user;
    },
    saveEmail(state, e) {
      state.email = e;
    },
    removeEmail(state) {
      state.email = '';
    },
    signout(state) {
      state.status.isSignedIn = false;
      state.user = null;
    },
  }
};